var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableFetchEventListener, FetchEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isDefined, isEqualShallow } from '@philips-internal/oswald-ui-utils';
import { SKIP_FETCH_SYMBOL } from './fetch-symbol.js';
import { FetchProperties } from './fetch-types.js';
class FetchAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeFetch = new AbortableFetchEventListener();
        /** @event */
        this.onAfterFetch = new FetchEventListener();
        /** @event */
        this.onAbort = new FetchEventListener();
    }
    /**
     * Gets the parameters configured for the fetch.
     *
     * @returns the parameters configured for the fetch.
     */
    getParameters() {
        return this.state.parameters;
    }
    /**
    * Sets the parameters for the fetch.
    *
    * @param parameters - Parameters for the fetch.
    * @param options - Options for the set function.
    */
    setParameters(parameters, options = {}) {
        if (isEqualShallow(this.state.parameters, parameters)) {
            return;
        }
        const updatedState = {
            data: [],
            loading: true,
            parameters,
            reset: true,
        };
        if (isDefined(options.skip)) {
            updatedState[SKIP_FETCH_SYMBOL] = options.skip;
        }
        this.setState(updatedState);
    }
    /**
     * Sets the lazy property of the fetch.
     *
     * @param lazy - If the fetch is lazy.
     */
    setLazy(lazy) {
        this.setState({ lazy });
    }
    /**
     * Checks if the fetch is lazy.
     *
     * @returns a boolean indicating if the fetch is lazy.
     */
    isLazy() {
        return this.state.lazy;
    }
    /**
     * Sets the endpoint property of the fetch.
     *
     * @param endpoint - The endpoint for the fetch.
     * @param options - Options for the set function.
     */
    setEndpoint(endpoint, options = {}) {
        const updatedState = {
            endpoint,
        };
        if (isDefined(options.skip)) {
            updatedState[SKIP_FETCH_SYMBOL] = options.skip;
        }
        // TODO: validate endpoint
        this.setState(updatedState);
    }
    /**
     * Gets the endpoint configured for the fetch.
     *
     * @returns the endpoint configured for the fetch.
     */
    getEndpoint() {
        return this.state.endpoint ?? FetchProperties.endpoint.defaultValue;
    }
    /**
     * Aborts the fetch request.
     */
    abort() {
        const abortController = this.state.abortController;
        if (abortController) {
            abortController.abort();
            this.onAbort.fire();
        }
    }
    /**
     * Force the fetch request.
     */
    forceFetch() {
        this.setState({ accumulate: false, forceFetch: true, page: 0 });
    }
    /**
     * Gets the total count header configured for the fetch.
     *
     * @returns the total count header configured for the fetch.
     */
    getTotalCountHeader() {
        return this.state.totalCountHeader ?? FetchProperties.totalCountHeader.defaultValue;
    }
    /**
     * Sets the total count header property of the fetch.
     *
     * @param totalCountHeader - The total count header for the fetch.
     */
    setTotalCountHeader(totalCountHeader) {
        this.setState({ totalCountHeader });
    }
    /**
     * Gets the data returned by the fetch.
     *
     * @returns the data returned by the fetch.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Get the current child API.
     */
    getChild() {
        const values = Array.from(this.childrenAPIs.values());
        return values[0];
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FetchAPI.prototype, "onBeforeFetch", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FetchAPI.prototype, "onAfterFetch", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FetchAPI.prototype, "onAbort", void 0);
export { FetchAPI, };
//# sourceMappingURL=fetch-api.js.map